import { render, staticRenderFns } from "./ListLocal.vue?vue&type=template&id=037e70a9"
import script from "./ListLocal.vue?vue&type=script&lang=js"
export * from "./ListLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports